module.exports = __webpack_public_path__ + "img/wj02bg.81ac5b88.jpg";